import './responsive.css';
import './i18n';
import './config/setupMonacoLoader';
import { App as AntApp } from 'antd';
import ReactDOM from 'react-dom/client';
import { App } from './Components/app/App';
import React, { Suspense } from 'react';
import * as serviceWorker from './serviceWorker';
import { cssVariablesWithTemplates } from './theme';
import { BrandProvider } from './theme/BrandProvider';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
import { registerSuperProperties } from './utils/analytics';
import { createLogger } from './utils/logger';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY?.trim();
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST?.trim() ?? 'https://us.i.posthog.com';
const logger = createLogger('bootstrap');

if (POSTHOG_KEY) {
  try {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      capture_pageview: false,
      capture_pageleave: false,
      disable_session_recording: true,
    });
    // Register synchronously, so app_version / surface / env ride on every event
    // captured afterwards — including the platform_* ones emitted by @shared/inbox
    // before any user has logged in (IMP-311).
    registerSuperProperties();
  } catch (error) {
    logger.error('PostHog initialization failed — analytics disabled for this session', error);
  }
}

// Add CSS variables to document.
// `cssVariablesWithTemplates` trae ademas los bloques `body.template-*`: sin
// ellos el CSS escrito a mano no repinta al cambiar de marca.
const style = document.createElement('style');
style.innerHTML = cssVariablesWithTemplates;
document.head.appendChild(style);

const container: any = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <Suspense>
    <PostHogProvider client={posthog}>
      {/* Sin `resolver` la app corre con DEFAULT_TEMPLATE — el comportamiento
          previo. La fuente de la marca es la decision abierta de `spec.md` §6;
          cuando se tome, se enchufa aca y en ningun otro lado. */}
      <BrandProvider configProviderProps={{ modal: { zIndex: 1060 } }}>
        <AntApp component={false}>
          <App />
        </AntApp>
      </BrandProvider>
    </PostHogProvider>
  </Suspense>,
);

serviceWorker.unregister();
